import React, { Suspense, useState } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@tanstack/react-query';
import {
  InputSection,
  UserSettingsSection,
  TitleSection,
} from './UserSettingsStyles.styles';
import { httpDeleteUserAccount } from '../../Hooks/user/user.delete.hooks';
import Auth from '../../Helpers/auth';
import { useNavigate } from 'react-router-dom';
import ConfirmDeleteButton from '../../AdminRoutes/EditRoutes/ConfirmDelete/ConfirmDeleteButton.component';

const DeleteAccount = ({ user }) => {
  const [err, setErr] = useState('');
  const navigate = useNavigate();

  const mutation = useMutation({
    mutationFn: () => httpDeleteUserAccount(user?._id),
    onError: () => {
      setErr('Your account could not be deleted');
    },
    onSuccess: () => {
      setErr('Your account has been deleted, you will now be logged out');
      setTimeout(() => {
        Auth.logout();
        navigate('/');
      }, 8000);
    },
  });

  const deleteUser = async () => {
    setErr('Account is deleting...');
    if (!user?._id) {
      setErr('User ID is not available');
      return;
    }
    mutation.mutate(user._id);
  };
  return (
    <>
      <UserSettingsSection>
        <TitleSection>
          <h4>Delete your account</h4>
        </TitleSection>
        <InputSection>
          <Suspense fallback={<div>Loading button...</div>}>
            <ConfirmDeleteButton
              onDelete={deleteUser}
              itemName="your account"
            />
          </Suspense>
        </InputSection>
      </UserSettingsSection>
      <p>{err}</p>
    </>
  );
};
DeleteAccount.propTypes = {
  user: PropTypes.object,
};

export default DeleteAccount;
